import { useState } from 'react';
import { Popover } from '../Popover';

interface FilterMenuProps {
  name: string;
  icon?: React.ReactNode;
  filterCount?: number;
  children: React.ReactNode;
}

export const FilterMenu = ({ name, icon, filterCount = 0, children }: FilterMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      popoverToggle={
        <button
          className={`button chiclet-filter-toggle${filterCount > 0 ? ' active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {icon && <span className="chiclet-filter-icon">{icon}</span>}
          {name}
          {filterCount > 0 && <span className="chiclet-filter-count">({filterCount})</span>}
        </button>
      }
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      className="chiclet-filter filter-menu"
      height={500}
    >
      <div className="filter-menu-content">{children}</div>
    </Popover>
  );
};
